import axiosV1 from "@/plugins/axios/configV2";
const API_PREFIX = "events";
export default {
	// All events no pagination
    getAllEvents(params = {}) {
        const url = `${API_PREFIX}/list`;
        return axiosV1.get(url, { params });
    },
	// Get Events
    getEvents(params = {}) {
		// TEST DATA
		// return {
		// 	data: {
		// 		"data": [
		// 			{
		// 				"id": 1,
		// 				"title": "zxc",
		// 				"type": "test z",
		// 				"description": "test z",
		// 				"location": "z",
		// 				"url": "http://www.z.com",
		// 				"image": "/storage/events/banner/1.png?t=1765477795",
		// 				"qr_image": "/storage/events/qr/1.png?t=1765479777",
		// 				"start_date": "2025-12-17",
		// 				"end_date": "2025-12-19",
		// 				"registration_start_date": "2025-12-16",
		// 				"registration_end_date": "2025-12-20",
		// 				"registration_limit": 3,
		// 				"points": 0,
		// 				"status": "Ongoing",
		// 				"total_participants": 1,
		// 				"is_registration_full": false,
		// 				"last_update_date_time": "2025-12-16T03:26:56.000000Z"
		// 			},
		// 			{
		// 				"id": 3,
		// 				"title": "test",
		// 				"type": "test type",
		// 				"description": "test desc",
		// 				"location": "",
		// 				"url": "http://www.test1.com",
		// 				"image": "/storage/events/banner/3.png?t=1765478368",
		// 				"qr_image": "/storage/events/qr/3.png?t=1765478368",
		// 				"start_date": "2025-12-14",
		// 				"end_date": "2025-12-15",
		// 				"registration_start_date": "2025-12-12",
		// 				"registration_end_date": "2025-12-14",
		// 				"registration_limit": 1,
		// 				"points": 0,
		// 				"status": "Ended",
		// 				"total_participants": 1,
		// 				"is_registration_full": true,
		// 				"last_update_date_time": "2025-12-11T18:39:28.000000Z"
		// 			},
		// 			{
		// 				"id": 6,
		// 				"title": "Event 3",
		// 				"type": "Open to All",
		// 				"description": "<p>http:\/\/canonalpha.local\/events\/add<\/p>",
		// 				"location": "A",
		// 				"url": "http:\/\/canonalpha.local\/events\/add",
		// 				"image": "\/storage\/events\/banner\/6.png?t=1765966262",
		// 				"qr_image": "\/storage\/events\/qr\/6.png?t=1765966262",
		// 				"start_date": "2026-01-19",
		// 				"end_date": "2026-01-22",
		// 				"registration_start_date": "2025-12-23",
		// 				"registration_end_date": "2025-12-24",
		// 				"registration_limit": 0,
		// 				"points": 0,
		// 				"status": "Upcoming",
		// 				"total_participants": 0,
		// 				"is_registration_full": false,
		// 				"last_update_date_time": "2025-12-17T10:11:02.000000Z"
		// 			},
		// 			{
		// 				"id": 5,
		// 				"title": "Event 2",
		// 				"type": "Open to All",
		// 				"description": "<p>http:\/\/canonalpha.local\/events\/add<\/p>",
		// 				"location": "T",
		// 				"url": "http:\/\/canonalpha.local\/events\/add",
		// 				"image": "\/storage\/events\/banner\/5.png?t=1765966112",
		// 				"qr_image": "\/storage\/events\/qr\/5.png?t=1765966113",
		// 				"start_date": "2025-12-31",
		// 				"end_date": "2026-01-07",
		// 				"registration_start_date": "2025-12-24",
		// 				"registration_end_date": "2025-12-25",
		// 				"registration_limit": 0,
		// 				"points": 0,
		// 				"status": "Upcoming",
		// 				"total_participants": 0,
		// 				"is_registration_full": false,
		// 				"last_update_date_time": "2025-12-17T10:08:33.000000Z"
		// 			},
		// 			{
		// 				"id": 4,
		// 				"title": "Add Event",
		// 				"type": "Open to All",
		// 				"description": "<p>http:\/\/canonalpha.local\/events\/add<\/p>",
		// 				"location": "TRA",
		// 				"url": "http:\/\/canonalpha.local\/events\/add",
		// 				"image": "\/storage\/events\/banner\/4.png?t=1765937862",
		// 				"qr_image": "\/storage\/events\/qr\/4.png?t=1765937862",
		// 				"start_date": "2025-12-26",
		// 				"end_date": "2025-12-31",
		// 				"registration_start_date": "2025-12-22",
		// 				"registration_end_date": "2025-12-23",
		// 				"registration_limit": 1,
		// 				"points": 0,
		// 				"status": "Upcoming",
		// 				"total_participants": 0,
		// 				"is_registration_full": false,
		// 				"last_update_date_time": "2025-12-17T02:17:42.000000Z"
		// 			},
		// 			{
		// 				"id": 3,
		// 				"title": "Event Inactive",
		// 				"type": "Open to All",
		// 				"description": "<p>http:\/\/canonalpha.local\/events\/add<\/p>",
		// 				"location": "Taguig",
		// 				"url": "http:\/\/canonalpha.local\/events\/add",
		// 				"image": "\/storage\/events\/banner\/3.png?t=1765934127",
		// 				"qr_image": "\/storage\/events\/qr\/3.png?t=1765934127",
		// 				"start_date": "2026-01-22",
		// 				"end_date": "2026-01-24",
		// 				"registration_start_date": "2025-12-22",
		// 				"registration_end_date": "2025-12-24",
		// 				"registration_limit": 2000,
		// 				"points": 0,
		// 				"status": "Inactive",
		// 				"total_participants": 0,
		// 				"is_registration_full": false,
		// 				"last_update_date_time": "2025-12-17T01:15:26.000000Z"
		// 			},
		// 			{
		// 				"id": 2,
		// 				"title": "Event 2",
		// 				"type": "Exclusive to Canon Users Only",
		// 				"description": "<p>http:\/\/canonalpha.local\/events\/add<\/p>",
		// 				"location": "MNL",
		// 				"url": "http:\/\/canonalpha.local\/events\/add",
		// 				"image": "\/storage\/events\/banner\/2.png?t=1765934065",
		// 				"qr_image": "\/storage\/events\/qr\/2.png?t=1765934065",
		// 				"start_date": "2026-01-01",
		// 				"end_date": "2026-01-03",
		// 				"registration_start_date": "2025-12-24",
		// 				"registration_end_date": "2025-12-25",
		// 				"registration_limit": 1000,
		// 				"points": 0,
		// 				"status": "Upcoming",
		// 				"total_participants": 0,
		// 				"is_registration_full": false,
		// 				"last_update_date_time": "2025-12-17T01:14:24.000000Z"
		// 			},
		// 			{
		// 				"id": 1,
		// 				"title": "Event 1",
		// 				"type": "Open to All",
		// 				"description": "<p>http:\/\/canonalpha.local\/events\/add<\/p>",
		// 				"location": "BGC",
		// 				"url": "http:\/\/canonalpha.local\/events\/add",
		// 				"image": "\/storage\/events\/banner\/1.png?t=1765898899",
		// 				"qr_image": "\/storage\/events\/qr\/1.png?t=1765898900",
		// 				"start_date": "2025-12-31",
		// 				"end_date": "2026-01-02",
		// 				"registration_start_date": "2025-12-23",
		// 				"registration_end_date": "2025-12-24",
		// 				"registration_limit": 1000,
		// 				"points": 1000,
		// 				"status": "Upcoming",
		// 				"total_participants": 1,
		// 				"is_registration_full": false,
		// 				"last_update_date_time": "2025-12-16T15:28:19.000000Z"
		// 			}
		// 		],
		// 		"links": {
		// 			"first": "http:\/\/canonalpha.local\/v1\/events?page=1",
		// 			"last": "http:\/\/canonalpha.local\/v1\/events?page=1",
		// 			"prev": null,
		// 			"next": null
		// 		},
		// 		"meta": {
		// 			"current_page": 1,
		// 			"from": 1,
		// 			"last_page": 1,
		// 			"links": [
		// 				{
		// 					"url": null,
		// 					"label": "&laquo; Previous",
		// 					"active": false
		// 				},
		// 				{
		// 					"url": "http:\/\/canonalpha.local\/v1\/events?page=1",
		// 					"label": "1",
		// 					"active": true
		// 				},
		// 				{
		// 					"url": null,
		// 					"label": "Next &raquo;",
		// 					"active": false
		// 				}
		// 			],
		// 			"path": "http:\/\/canonalpha.local\/v1\/events",
		// 			"per_page": 10,
		// 			"to": 6,
		// 			"total": 6
		// 		}
		// 	}
		// }
        const url = `${API_PREFIX}`;
        return axiosV1.get(url, { params });
    },
	// View Event
    viewEvent(id = null) {
		// return {
		// 	data: {
		// 		"data": {
		// 			"id": 10,
		// 			"title": "Test Event",
		// 			"type": "Open to All",
		// 			"code": "r7oweV",
		// 			"description": "<p><strong>Test info<\/strong><\/p><ul><li><strong>1<\/strong><\/li><li><strong>2<\/strong><\/li><li><strong>3<\/strong><\/li><\/ul>",
		// 			"location": "BGC",
		// 			"url": "http:\/\/canonalpha.local\/events\/add",
		// 			"image": "\/storage\/events\/banner\/10.png?t=1766025499",
		// 			"qr_image": "\/storage\/events\/qr\/10.png?t=1766025422",
		// 			"start_date": "2025-12-28",
		// 			"end_date": "2025-12-31",
		// 			"registration_start_date": "2025-12-16",
		// 			"registration_end_date": "2025-12-20",
		// 			"registration_limit": 1000,
		// 			"points": 100,
		// 			"status": "Upcoming",
		// 			"total_participants": 0,
		// 			"is_registration_full": false,
		// 			"last_update_date_time": "2025-12-18T02:38:19.000000Z"
		// 		}
		// 	}
		// }
		const url = `${API_PREFIX}/view/${id}`
        return axiosV1.get(url);
    },
    // Add Event
	addEvent(payload = {}) {
		const url = `${API_PREFIX}/add`;
		const formData = new FormData();

		// basic fields
		['title', 'url', 'type', 'description', 'location', 'registration_limit', 'type', 'points_expiry'].forEach(field => {
			if (payload[field] !== undefined) {
				formData.append(field, payload[field]);
			}
		});

		// date range (array of exactly 2 items)
		if (Array.isArray(payload.dates) && payload.dates.length === 2) {
			formData.append('dates[0]', payload.dates[0]); // start date
			formData.append('dates[1]', payload.dates[1]); // end date
		}

		// registration dates
		if (payload.registration_start_date) {
			formData.append('registration_start_date', payload.registration_start_date);
		}
		if (payload.registration_end_date) {
			formData.append('registration_end_date', payload.registration_end_date);
		}

		// optional fields
		if (payload.reg_limit != null) formData.append('reg_limit', payload.reg_limit);
		if (payload.points != null) formData.append('points', payload.points);

		// status
		formData.append('status', payload.status);

		// image/file
		if (payload.image) formData.append('image', payload.image);

		return axiosV1.post(url, formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		});
	},
    // Update Event
    updateEvent(id = null, payload = {}) {
		const url = `${API_PREFIX}/update/${id}`
        
		const formData = new FormData();

		// basic fields
		['title', 'url', 'type', 'description', 'location', 'registration_limit', 'type', 'points_expiry'].forEach(field => {
			if (payload[field] !== undefined) {
				formData.append(field, payload[field]);
			}
		});

		// date range (array of exactly 2 items)
		if (Array.isArray(payload.dates) && payload.dates.length === 2) {
			formData.append('dates[0]', payload.dates[0]); // start date
			formData.append('dates[1]', payload.dates[1]); // end date
		}

		// registration dates
		if (payload.registration_start_date) {
			formData.append('registration_start_date', payload.registration_start_date);
		}
		if (payload.registration_end_date) {
			formData.append('registration_end_date', payload.registration_end_date);
		}

		// optional fields
		if (payload.reg_limit != null) formData.append('reg_limit', payload.reg_limit);
		if (payload.points != null) formData.append('points', payload.points);

		// status
		formData.append('status', payload.status);

		// image/file
		if (payload.image) {
			formData.append('image', payload.image)
		}

		return axiosV1.post(url, formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		});
    },
	// Get Events Audit Logs
    getEventsAuditLogs(id) {
        const url = `${API_PREFIX}/audit-log/${id}`;
        return axiosV1.get(url);
    },
	// Get Participants
    getParticipants(id, params = {}) {
        const url = `${API_PREFIX}/${id}/participants`;
        return axiosV1.get(url, { params });
    },
	// Export Participants
    exportParticipants(id, params = {}) {
        const url = `${API_PREFIX}/${id}/export/participants`;
        return axiosV1.get(url, { params });
    },
	// Update Event Code
    updateEventCode(id = null, payload = {}) {
		const url = `${API_PREFIX}/update/code/${id}`
        
		const formData = new FormData();
		formData.append('code', payload.code);

		return axiosV1.post(url, formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		});
    },
	// Get Feedback Form Details
    getFeedbackFormDetails(id, params = {}) {
        const url = `${API_PREFIX}/get/feedback-form/${id}`;
        return axiosV1.get(url, { params });
    },
	// Update Feedback Form Details - Create / Update
	updateFeedbackFormDetails(id = null, payload = {}) {
		const url = `${API_PREFIX}/feedback-form/${id}`

		return axiosV1.post(url, {
			visibility: payload.visibility,
			status: payload.status,
			availability: payload.availability,
			start_date: payload.start_date,
			end_date: payload.end_date,
			start_time: payload.start_time,
			end_time: payload.end_time,
			fields: payload.fields, // ✅ array works in JSON
		}, {
			headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			},
		})
	},
	// Get Feedback Form Responses
    getResponses(id, params = {}) {
		// return {
		// 	data: {
		// 		"data": [
		// 			{
		// 				"name": "Jessa Cena",
		// 				"questions": "Question 1.1",
		// 				"type": "Text Field",
		// 				"answer": "test 1",
		// 				"date_submitted": "2025-12-19T10:29:36.000000Z"
		// 			},
		// 			{
		// 				"name": "Jessa Cena",
		// 				"questions": "Question 2.1",
		// 				"type": "Text Area",
		// 				"answer": "test 1",
		// 				"date_submitted": "2025-12-19T10:29:36.000000Z"
		// 			},
		// 			{
		// 				"name": "Jessa Cena",
		// 				"questions": "Question 3.1",
		// 				"type": "Checkbox",
		// 				"answer": "test 1, test 2",
		// 				"date_submitted": "2025-12-19T10:29:36.000000Z"
		// 			},
		// 			{
		// 				"name": "Jessa Cena",
		// 				"questions": "Question 1.1",
		// 				"type": "Text Field",
		// 				"answer": "test 1",
		// 				"date_submitted": "2025-12-19T10:29:36.000000Z"
		// 			},
		// 			{
		// 				"name": "Jessa Cena",
		// 				"questions": "Question 2.1",
		// 				"type": "Text Area",
		// 				"answer": "test 1",
		// 				"date_submitted": "2025-12-19T10:29:36.000000Z"
		// 			},
		// 			{
		// 				"name": "Jessa Cena",
		// 				"questions": "Question 3.1",
		// 				"type": "Checkbox",
		// 				"answer": "test 1, test 2",
		// 				"date_submitted": "2025-12-19T10:29:36.000000Z"
		// 			},
		// 			{
		// 				"name": "Jessa Cena",
		// 				"questions": "Question 1.1",
		// 				"type": "Text Field",
		// 				"answer": "test 1",
		// 				"date_submitted": "2025-12-19T10:29:36.000000Z"
		// 			},
		// 			{
		// 				"name": "Jessa Cena",
		// 				"questions": "Question 2.1",
		// 				"type": "Text Area",
		// 				"answer": "test 1",
		// 				"date_submitted": "2025-12-19T10:29:36.000000Z"
		// 			},
		// 			{
		// 				"name": "Jessa Cena",
		// 				"questions": "Question 3.1",
		// 				"type": "Checkbox",
		// 				"answer": "test 1, test 2",
		// 				"date_submitted": "2025-12-19T10:29:36.000000Z"
		// 			},
		// 			{
		// 				"name": "Jessa Cena",
		// 				"questions": "Question 3.1",
		// 				"type": "Checkbox",
		// 				"answer": "test 1, test 2",
		// 				"date_submitted": "2025-12-19T10:29:36.000000Z"
		// 			}
		// 		],
		// 		"links": {
		// 			"first": "http://canon.local/v1/events/view/feedback/responses/1?page=1",
		// 			"last": "http://canon.local/v1/events/view/feedback/responses/1?page=1",
		// 			"prev": null,
		// 			"next": null
		// 		},
		// 		"meta": {
		// 			"current_page": 1,
		// 			"from": 1,
		// 			"last_page": 2,
		// 			"links": [
		// 				{
		// 					"url": null,
		// 					"label": "&laquo; Previous",
		// 					"active": false
		// 				},
		// 				{
		// 					"url": "http://canon.local/v1/events/view/feedback/responses/1?page=1",
		// 					"label": "1",
		// 					"active": true
		// 				},
		// 				{
		// 					"url": null,
		// 					"label": "Next &raquo;",
		// 					"active": false
		// 				}
		// 			],
		// 			"path": "http://canon.local/v1/events/view/feedback/responses/1",
		// 			"per_page": 10,
		// 			"to": 1,
		// 			"total": 11
		// 		}
		// 	}
		// }
        const url = `${API_PREFIX}/view/feedback/responses/${id}`;
        return axiosV1.get(url, { params });
    },
	// Export Responses
    exportResponses(id, params = {}) {
        const url = `${API_PREFIX}/export/feedback/responses/${id}`;
        return axiosV1.get(url, { params });
    },
};
